// 「装到手机桌面」提示：手机浏览器里打开、还没装成 PWA 时显示（安卓 Chrome 可一键安装，iPhone 说明在 Safari 里怎么加）
import { useEffect, useState } from "react";

interface InstallPromptEvent extends Event {
  prompt: () => Promise<void>;
}

const DISMISS_KEY = "csp-install-hint-dismissed";

function standalone(): boolean {
  return window.matchMedia?.("(display-mode: standalone)").matches || (navigator as { standalone?: boolean }).standalone === true;
}

export function InstallHint() {
  const [prompt, setPrompt] = useState<InstallPromptEvent | null>(null);
  const [hidden, setHidden] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === "1";
    } catch {
      return false;
    }
  });
  useEffect(() => {
    const on = (e: Event) => {
      e.preventDefault();
      setPrompt(e as InstallPromptEvent);
    };
    window.addEventListener("beforeinstallprompt", on);
    return () => window.removeEventListener("beforeinstallprompt", on);
  }, []);
  const ua = navigator.userAgent;
  const ios = /iPhone|iPad|iPod/.test(ua);
  const mobile = ios || /Android/.test(ua);
  if (hidden || standalone() || !mobile || (!ios && !prompt)) return null;
  const dismiss = () => {
    setHidden(true);
    try {
      localStorage.setItem(DISMISS_KEY, "1");
    } catch {
      /* 忽略 */
    }
  };
  return (
    <div className="notice install-hint" data-testid="install-hint">
      <b>添加到主屏幕</b>
      {prompt ? (
        <span>装到手机桌面，像 App 一样打开，有新版本自动更新。</span>
      ) : (
        <span>在 Safari 里点底部「分享」按钮，选「添加到主屏幕」。以后从桌面图标打开，有新版本自动更新。</span>
      )}
      <span className="row">
        {prompt && (
          <button type="button" className="btn btn-small btn-primary" onClick={() => void prompt.prompt().finally(() => setPrompt(null))}>
            安装
          </button>
        )}
        <button type="button" className="btn btn-small" onClick={dismiss}>
          不再提示
        </button>
      </span>
    </div>
  );
}
